import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { Row, Col} from 'react-bootstrap';
import { Button, Table, TableBody, TableCell, TableContainer, TableRow, Chip } from '@mui/material';
import { useEffect } from "react";
import { getGatewaysById, getSensorsByQuery } from "components/axios/iotAxios";
import { useState } from "react";
import dayjs from "dayjs";
import { getEquipmentsByQuery } from "components/axios/equipmentAxios";
import { useEnumApi } from "contexts/EnumApiContext";

const GatewayViewSetting = () => {
  const { getEnumValueByEnumNameAndCode } = useEnumApi();
  const { t } = useTranslation();

  const {id} = useParams();

  const [isLoading, setIsLoading] = useState(false);
  const [gateway, setGateway] = useState({});
  const [sensors, setSensors] = useState([]);
  const [equipments, setEquipments] = useState([]);
  const connectProblemDay = dayjs(new Date()).subtract(7, "d").format("YYYY-MM-DD");
  const today = new Date();

  useEffect(()=>{
    if (!isLoading) {
      Promise.all([
        getGatewaysById(id).then((res)=>{
          setGateway(res);
        })
        ,
        getSensorsByQuery({"gateway.id":id}).then((res3)=>{
          if (res3 && res3._embedded)
            setSensors(res3._embedded.sensors);
        })
        ,
        getEquipmentsByQuery({"gateways.gateway.id":id}).then((res4)=>{
          if (res4 && res4._embedded)
            setEquipments(res4._embedded.equipments);
        })
      ]).then(()=>{
        setIsLoading(true);
      })
    }
  },[isLoading, id]);

  if (isLoading && gateway) {
      let connectProblemColor = "view_td2";
      let diffDate = 0;
      if (gateway.latestCommedAt) {
        if (gateway.latestCommedAt && gateway.latestCommedAt < connectProblemDay) {
            connectProblemColor = "view_td2 red";
        }
        diffDate = ((today.getTime() - new Date(gateway.latestCommedAt).getTime()) / (24*60*60*1000)).toFixed(0);
      } else {
        connectProblemColor = "view_td2 red";
      }

      return (
      <div style={{padding:"15px 0"}}>
          <Row>
            <Col sm={8} className="main_left">
              <div style={{marginBottom:"10px"}}>
                  <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp;
                  <Chip label={t('message.common.title.gateway.information')} style={{color:"#fff", backgroundColor:"#6a7075", borderRadius:"4px"}} />
              </div>
  
              <TableContainer key={0}>
                <Table sx={{ minWidth: 1000 }} aria-label="simple table" className="same_width view_table" style={{borderTop:"2px solid #a2a2a2"}} >
                  <TableBody>
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.manufacturing.company')}</TableCell>
                      <TableCell className="view_td2">
                      {gateway.madeBy}&nbsp;
                      </TableCell>
                      <TableCell className="th">S/N</TableCell>
                      <TableCell className="view_td2">{gateway.sn}&nbsp;</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.installation.date')}</TableCell>
                      <TableCell className="view_td2">{gateway.instlYmd}&nbsp;</TableCell>
                      <TableCell className="th">{t('message.common.subtitle.last.communication')}</TableCell>
                      <TableCell className={connectProblemColor}>{gateway.latestCommedAt && diffDate+t('message.common.text.day.ago')}&nbsp;</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
  
              <br/>
              <div style={{marginBottom:"10px"}}>
                  <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp;
                  <Chip label={t('message.common.title.connection.sensor')} style={{color:"#fff", backgroundColor:"#6a7075", borderRadius:"4px"}} />
              </div>
              <TableContainer key={2}>
                <Table className="list_table" sx={{ minWidth: 400 }} aria-label="simple table" style={{borderTop:"2px solid #a2a2a2"}}>
                  <TableBody>
                    <TableRow>
                      <TableCell className="th">No.</TableCell>
                      <TableCell className="th">{t('message.common.subtitle.manufacturing.company')}</TableCell>
                      <TableCell className="th">S/N</TableCell>
                      <TableCell className="th">X, Y, Z</TableCell>
                      <TableCell className="th">{t('message.common.subtitle.last.communication')}</TableCell>
                      <TableCell className="th">{t('message.common.subtitle.installation.date')}</TableCell>
                    </TableRow>
                    { sensors && sensors.map(function(con, i) {
                      connectProblemColor = "view_td2";
                      if (sensors[i].latestCommedAt) {
                        if (sensors[i].latestCommedAt && dayjs(sensors[i].latestCommedAt).format('YYYY-MM-DD') < connectProblemDay) {
                            connectProblemColor = "view_td2 red";
                        }
                        diffDate = ((today.getTime() - new Date(sensors[i].latestCommedAt).getTime()) / (24*60*60*1000)).toFixed(0);
                      } else {
                        connectProblemColor = "view_td2 red";
                      }
                      return(
                    <TableRow key={i}>
                      <TableCell align="center">{sensors.length-i}</TableCell>
                      <TableCell align="center">{sensors[i].madeBy}&nbsp;</TableCell>
                      <TableCell align="center">{sensors[i].sn}</TableCell>
                      <TableCell align="center">
                        {sensors[i].axial && getEnumValueByEnumNameAndCode("SensorDirection", sensors[i].axial) && getEnumValueByEnumNameAndCode("SensorDirection", sensors[i].axial)[0].title}
                        {sensors[i].radial && getEnumValueByEnumNameAndCode("SensorDirection", sensors[i].radial) && ', '+getEnumValueByEnumNameAndCode("SensorDirection", sensors[i].radial)[0].title}
                        {sensors[i].vertical && getEnumValueByEnumNameAndCode("SensorDirection", sensors[i].vertical) && ', '+getEnumValueByEnumNameAndCode("SensorDirection", sensors[i].vertical)[0].title}
                      </TableCell>
                      <TableCell align="center" className={connectProblemColor}>{sensors[i].latestCommedAt && diffDate+t('message.common.text.day.ago')}</TableCell>
                      <TableCell align="center">{sensors[i].instlYmd}</TableCell>
                    </TableRow>
                      )
                  }) }
                  </TableBody>
                </Table>
              </TableContainer>

              <div style={{marginTop:"10px"}}>
                  <Link to={'../'+window.location.search}><Button variant="contained" color="primary">{t('message.common.btn.list')}</Button></Link>
              </div>
            </Col>
  
            <Col sm={4} className="main_right">
              <div style={{marginBottom:"10px"}}>
                  <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp;
                  <Chip label={t('message.common.title.target.equipment.information')} style={{color:"#fff", backgroundColor:"#6a7075", borderRadius:"4px"}} />
              </div>

  
              { equipments && equipments.map(function(con, i) {
                  return(
              <TableContainer key={i}>
                <Table sx={{ minWidth: 400 }} aria-label="simple table" className="same_width view_table" style={{borderTop:"2px solid #a2a2a2"}} >
                  <TableBody>
                    {/* <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.subwayline')}</TableCell>
                      <TableCell className="view_td">
                        {equipments[i].station && equipments[i].station.workingPart && equipments[i].station.workingPart.subwayLine 
                        && getEnumValueByEnumNameAndCode("SubwayLine", equipments[i].station.workingPart.subwayLine)
                        && getEnumValueByEnumNameAndCode("SubwayLine", equipments[i].station.workingPart.subwayLine)[0].title}
                      </TableCell>
                      <TableCell className="th">{t('message.common.subtitle.workingPart')}</TableCell>
                      <TableCell className="view_td">
                        {equipments[i].station && equipments[i].station.workingPart && equipments[i].station.workingPart.name}
                      </TableCell>
                    </TableRow> */}
                    {/* <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.station')}</TableCell>
                      <TableCell className="view_td" colSpan={3}>
                        {equipments[i].station && equipments[i].station.name}
                      </TableCell>
                    </TableRow> */}
                    <TableRow>
                      <TableCell className="th">{t('message.common.subtitle.equipment.name')}</TableCell>
                      <TableCell className="view_td" colSpan={3}>
                        {equipments[i].name}({equipments[i].equipmentNo})
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
                  )
              })}
            </Col>
          </Row>
      </div>
      )
  }
}

export default GatewayViewSetting;